var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackageConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5031_11825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9497 9.34253C11.3901 9.34253 10.8623 9.48159 10.3989 9.72666V6.47713H12.3716L7.36603 0L1.86203 6.47713H3.78825V7.25466L0.721436 11.2637H2.22437V16H10.3988V15.6159C10.8623 15.8609 11.39 16 11.9497 16C13.7852 16 15.2785 14.5067 15.2785 12.6713C15.2785 10.8358 13.7852 9.34253 11.9497 9.34253ZM5.1255 10.3306V15.0414H3.15753V10.3306H2.61015L4.25637 8.17856L5.77175 10.3306H5.1255ZM6.05865 15.0414V11.2637H7.57006L4.7214 7.21812V5.54397H3.87953L7.33165 1.48156L10.4712 5.544H9.46575V10.458C8.94069 11.0467 8.62103 11.8223 8.62103 12.6713C8.62103 13.5203 8.94069 14.2959 9.46575 14.8846V15.0414H6.05865V15.0414ZM11.9497 15.0668C10.6288 15.0668 9.55415 13.9922 9.55415 12.6713C9.55415 11.3503 10.6288 10.2757 11.9497 10.2757C13.2707 10.2757 14.3453 11.3503 14.3453 12.6713C14.3453 13.9922 13.2707 15.0668 11.9497 15.0668Z",
    fill: "#53AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5653 12.8754L10.9838 12.2939L10.324 12.9537L11.5653 14.195L13.5756 12.1847L12.9158 11.5249L11.5653 12.8754Z",
    fill: "#53AEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5031_11825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageConfig);
export default __webpack_public_path__ + "static/media/package_config.94382d8c46f87cb264bb31e6e79a7f1e.svg";
export { ForwardRef as ReactComponent };